import api from "./api";

export const getMyDriverPartner =
    async () => {
        try {
            const response =
                await api.get(
                    "/driver-partner-management/driver-partners/me"
                );

            return {
                success: true,
                data:
                    response.data
                        .data,
            };
        } catch (
            error
        ) {
            return {
                success: false,
                error:
                    error
                        .response
                        ?.data
                        ?.detail ||
                    "Failed to fetch driver partner profile.",
            };
        }
    };

export const registerDriverPartner =
    async (
        payload
    ) => {
        try {
            const formData =
                new FormData();

            formData.append(
                "payment_method",
                payload.payment_method
            );

            formData.append(
                "payment_account",
                payload.payment_account
            );

            formData.append(
                "agreement_accepted",
                payload.agreement_accepted
            );

            if (
                payload.referral_source
            ) {
                formData.append(
                    "referral_source",
                    payload.referral_source
                );
            }

            formData.append(
                "identity_proof",
                payload.identity_proof
            );

            if (
                payload.profile_image
            ) {
                formData.append(
                    "profile_image",
                    payload.profile_image
                );
            }

            const response =
                await api.post(
                    "/driver-partner-management/driver-partners/register",
                    formData,
                    {
                        headers:
                            {
                                "Content-Type":
                                    "multipart/form-data",
                            },
                    }
                );

            return {
                success: true,
                data:
                    response.data
                        .data,
            };
        } catch (
            error
        ) {
            return {
                success: false,
                error:
                    error
                        .response
                        ?.data
                        ?.detail ||
                    "Failed to register driver partner.",
            };
        }
    };

    export const updateDriverPartner =
    async (
        driverPartnerId,
        data
    ) => {
        try {
            const formData =
                new FormData();

            if (
                data.payment_method
            ) {
                formData.append(
                    "payment_method",
                    data.payment_method
                );
            }

            if (
                data.payment_account
            ) {
                formData.append(
                    "payment_account",
                    data.payment_account
                );
            }

            if (
                data.account_name
            ) {
                formData.append(
                    "account_name",
                    data.account_name
                );
            }

            if (
                data.account_number
            ) {
                formData.append(
                    "account_number",
                    data.account_number
                );
            }

            if (
                data.branch
            ) {
                formData.append(
                    "branch",
                    data.branch
                );
            }

            if (
                data.branch_code
            ) {
                formData.append(
                    "branch_code",
                    data.branch_code
                );
            }

            if (
                data.referral_source
            ) {
                formData.append(
                    "referral_source",
                    data.referral_source
                );
            }

            if (
                data.identity_proof
            ) {
                formData.append(
                    "identity_proof",
                    data.identity_proof
                );

                formData.append(
                    "identity_proof_extension",
                    data.identity_proof.name
                        .split(".")
                        .pop()
                );
            }

            if (
                data.profile_image
            ) {
                formData.append(
                    "profile_image",
                    data.profile_image
                );

                formData.append(
                    "profile_image_extension",
                    data.profile_image.name
                        .split(".")
                        .pop()
                );
            }
            for (const [key, value] of formData.entries()) {
    console.log(key, value);
}
            const response =
                await api.put(
                    `/driver-partner-management/driver-partners/${driverPartnerId}/update`,
                    formData,
                     {
                        headers:
                            {
                                "Content-Type":
                                    "multipart/form-data",
                            },
                    }
                );

            return {
                success: true,
                data:
                    response.data
                        .data,
            };
        } catch (
            error
        ) {
            return {
                success: false,
                error:
                    error
                        .response
                        ?.data
                        ?.detail ||
                    error.message,
            };
        }
    };

    export const fetchReferredDrivers =
    async (
        page = 1,
        size = 10
    ) => {
        try {
            const response =
                await api.get(
                    `/driver-partner-management/driver-partners/referred-drivers?page=${page}&size=${size}`
                );

            return {
                success: true,
                data:
                    response.data
                        .data,
            };
        } catch (
            error
        ) {
            return {
                success: false,
                error:
                    error
                        .response
                        ?.data
                        ?.detail ||
                    error.message,
            };
        }
    };

export const fetchReferralMilestones =
    async () => {
        try {
            const response =
                await api.get(
                    "/driver-partner-management/driver-partners/referral-milestones"
                );

            return {
                success: true,
                data:
                    response.data
                        .data,
            };
        } catch (
            error
        ) {
            return {
                success: false,
                error:
                    error
                        .response
                        ?.data
                        ?.detail ||
                    error.message,
            };
        }
    };